import React from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { userSelector } from '../reducers/current-user-selectors';

import { EmployeeUnreadMessagesBadge } from '../employee-messages/message-composer/employee-unread-messages-badge';
import { UiIconNav } from '../ui/ui-icon-nav';
import { UiNavIconTab } from '../ui/ui-nav-icon-tab';
import * as WebRoutes from '../web-routes';

import { legacyOrgUserTabs, orgAdminTabs } from '../util/navigation-tabs';

const mapStateToProps = (state: any) => ({
  user: userSelector(state),
});

type InputProps = {
  org: Org;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type Props = InputProps & ReduxProps & RouteComponentProps;

export const LegacyOrganizationNav = withRouter(
  connect(mapStateToProps)((props: Props) => {
    const {
      user,
      org,
      location: { pathname },
    } = props;
    const orgId = org.org_id;

    const userTabs = legacyOrgUserTabs(user, orgId, {
      messages: {
        children: <EmployeeUnreadMessagesBadge key="employeeMessagesBadge" orgId={orgId} />,
      },
    });

    const administrativeTabs = orgAdminTabs(user, orgId);

    const visibleTabs = userTabs.filter((tab) => tab.hasPermissions).map((tab) => tab.key);

    const getSelectedMobileTab = () => {
      if (pathname === WebRoutes.orgJobsRoute(orgId)) {
        return visibleTabs.indexOf('jobs');
      }
      if (pathname.includes(WebRoutes.orgAutomationsRoute(orgId))) {
        return visibleTabs.indexOf('automations');
      }
      if (pathname.includes(WebRoutes.employeeMessagesRoute({ orgId, employeeId: null }))) {
        return visibleTabs.indexOf('messages');
      }
      if (pathname.includes(WebRoutes.employeeAnnouncementsRoute(orgId, null))) {
        return visibleTabs.indexOf('announcements');
      }
      if (pathname === WebRoutes.employeesRoute(orgId)) {
        return visibleTabs.indexOf('directory');
      }
      if (pathname.includes(WebRoutes.employeeReferralsRoute(orgId))) {
        return visibleTabs.indexOf('referrals');
      }
      if (pathname.includes(WebRoutes.surveysRoute(orgId, null))) {
        return visibleTabs.indexOf('surveys');
      }
      return 0;
    };

    return (
      <UiIconNav
        variant="collapsible"
        mainTabs={userTabs}
        lowerTabs={administrativeTabs}
        DesktopComponent={UiNavIconTab}
        getSelectedTab={getSelectedMobileTab}
      />
    );
  }),
);
